import { createSvgIcon } from '../../createSvgIcon';
import { CHEVRON_PATH_D } from '../chevronPath';

export const ChevronUpIcon = createSvgIcon(
  <g transform="translate(0, 15) rotate(-90)">
    <path d={CHEVRON_PATH_D} fill="currentColor" />
  </g>,
  { displayName: 'ChevronUpIcon', viewBox: '0 0 27 15' }
);
